module.exports = __webpack_public_path__ + "static/3.4moveCameraBackwards-23ffe6596f8c39d88f61e653245e47df.gif";